"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../utils/hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Stopwatch = function Stopwatch(_ref) {
  var initialTime = _ref.initialTime,
    countdown = _ref.countdown,
    countdownAction = _ref.countdownAction,
    currentDate = _ref.currentDate,
    disabled = _ref.disabled,
    viewHours = _ref.viewHours;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    elapsed = _useState2[0],
    setElapsed = _useState2[1];
  var _useState3 = (0, _react.useState)(1000),
    _useState4 = _slicedToArray(_useState3, 2),
    delay = _useState4[0],
    setDelay = _useState4[1];
  var start = (0, _react.useRef)(Date.now());
  var _useState5 = (0, _react.useState)(initialTime),
    _useState6 = _slicedToArray(_useState5, 2),
    countdownValue = _useState6[0],
    setCountdownValue = _useState6[1];
  (0, _hooks.useInterval)(function () {
    if (!disabled) {
      if (countdown) {
        setCountdownValue(countdownValue - 1000);
      } else {
        setElapsed(Date.now() - start.current);
      }
    }
  }, delay);
  (0, _react.useEffect)(function () {
    if (countdownValue === 0 && countdown) {
      setDelay(null);
      if (countdownAction) countdownAction();
    }
  }, [countdownValue]);
  (0, _react.useEffect)(function () {
    if (currentDate) {
      start.current = currentDate;
    } else {
      start.current = Date.now();
    }
  }, [initialTime]);
  var convertToString = function convertToString(ms) {
    var showWith0 = function showWith0(value) {
      return value < 10 ? '0' + value : value;
    };
    var days = Math.floor(ms / (1000 * 60 * 60 * 24));
    var hours = showWith0(Math.floor(ms / (1000 * 60 * 60) % 24));
    var minutes = showWith0(Math.floor(ms / (1000 * 60) % 60));
    var seconds = showWith0(Math.floor(ms / 1000 % 60));
    return (parseInt(days, 10) ? days + 'd ' : '') + (viewHours || parseInt(hours, 10) ? hours + ':' : '') + minutes + ':' + seconds;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentDate ? convertToString(elapsed) : countdown ? convertToString(countdownValue) : convertToString(Math.abs(start.current - (initialTime || start.current)) + elapsed));
};
Stopwatch.propTypes = {
  initialTime: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].number]),
  countdown: _propTypes["default"].bool,
  countdownAction: _propTypes["default"].func,
  currentDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].number]),
  disabled: _propTypes["default"].bool,
  viewHours: _propTypes["default"].bool
};
Stopwatch.defaultProps = {
  disabled: false,
  viewHours: false
};
var _default = exports["default"] = Stopwatch;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/Stopwatch/Stopwatch.js
// module id = 145
// module chunks = 0